import { Routes, Route } from "react-router-dom";
import Login from "../Authpages/Login";
import Signup from "../Authpages/Signup";
import Signupconfirm from "../Authpages/Signupconfirm";
import Confirmation from "../Authpages/Confirmation";
import Forgotpassword from "../Authpages/Forgotpassword";
import ResetPwd from "../Authpages/ResetPassword";
import TCInfiniteLogin from "../Authpages/TCInfiniteLogin";
import LoginWithOTP from "../Authpages/LoginWithOTP";

import ShraddhaAdmin from "../AdminPages/Admin/ShraddhaAdmin";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/Signupconfirm" element={<Signupconfirm />} />
      <Route path="/confirmation" element={<Confirmation />} />
      <Route path="/forgot-password" element={<Forgotpassword />} />
      <Route path="/reset-password" element={<ResetPwd />} />
      <Route path="/AdminLogin" element={<ShraddhaAdmin />} />
      <Route path="/TCInfiniteLogin" element={<TCInfiniteLogin />} />
      <Route path="/LoginWithOTP" element={<LoginWithOTP />} />
    </Routes>
  );
};

export default AuthRoutes;
